// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__VfseO","star":"Rating_star__l2eBm","first_star":"Rating_first_star__qC33s","halfStar":"Rating_halfStar__GEGQJ"};